export default '/static/frontend/ReachDigital/12gobiking/dist/assets/mastercard2-dec5bacd.svg'